import React from 'react';
import { Grid } from '@mui/material';
import { Trans } from '@gamiphy/react-i18n';
import { TierConfig, TierConfigType } from '@gamiphy/bl/level';
import couponImg from './assets/coupon.svg';

type Props = {
  points: {
    gems?: number | string,
    exp?: number | string
  },
  withWelcomeCoupon?: boolean
  textColor?: string,
  tierConfig?: TierConfig,
}

const Points: React.FC<Props> = ({
  points,
  withWelcomeCoupon,
  textColor,
  tierConfig,
}) => (
  <Grid
    container
    direction="row"
    alignItems="center"
    spacing={1}
  >
    {
        !!points.exp && tierConfig?.type === TierConfigType.exp && (
          <Grid sx={{
            fontSize: '1.2rem',
            whiteSpace: 'nowrap',
            color: textColor || '#677683',
            textTransform: 'capitalize',
          }}
          >
            <Trans
              i18nKey="expValue"
              defaults="{{exp, exp}}"
              values={{
                exp: points.exp,
              }}
            />
          </Grid>
        )
      }
    {
        !!points.gems && (
          <Grid sx={{
            fontSize: '1.2rem',
            whiteSpace: 'nowrap',
            color: textColor || '#677683',
            textTransform: 'capitalize',
          }}
          >
            <Trans
              i18nKey="gemsValue"
              defaults="{{gems, gems}}"
              values={{
                gems: points.gems,
              }}
            />
          </Grid>
        )
      }
    {
        withWelcomeCoupon && (
          <Grid sx={{
            fontSize: '1.2rem',
            whiteSpace: 'nowrap',
            color: textColor || '#677683',
            textTransform: 'capitalize',
          }}
          >
            <Trans
              i18nKey="welcomeGift.discount.pointsTxt"
              defaults="<icon/> <span>Unlock coupon</>"
              components={{
                icon: <img style={{ verticalAlign: 'middle' }} src={couponImg} alt="" />,
                span: <span style={{ verticalAlign: 'middle' }} />,
              }}
            />
          </Grid>
        )
      }
  </Grid>
);

export default Points;
